/**
 * 서버 사이드 fetch 공용 유틸.
 *   - ApiError: HTTP 상태를 보존해 페이지가 404 와 그 외(401/5xx)를 구분할 수 있게 한다.
 *   - fetchJson / fetchText: 상태 검사 + 컨텍스트 라벨을 붙인 얇은 래퍼.
 * 기본적으로 ISR(next.revalidate) 캐시를 태우며, 필요 시 init 으로 override 한다.
 */

/** HTTP 상태를 보존하는 에러 — 페이지가 404 와 그 외(401/5xx)를 구분하기 위함 */
export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message?: string,
  ) {
    super(message ?? `API error ${status}`);
    this.name = "ApiError";
  }
}

const DEFAULT_REVALIDATE = 60;

export async function fetchJson<T>(
  url: string,
  context: string,
  init?: RequestInit,
): Promise<T> {
  const res = await fetch(url, { next: { revalidate: DEFAULT_REVALIDATE }, ...init });
  if (!res.ok) throw new ApiError(res.status, `${context}: ${res.status}`);
  return (await res.json()) as T;
}

export async function fetchText(
  url: string,
  context: string,
  init?: RequestInit,
): Promise<string> {
  const res = await fetch(url, { next: { revalidate: DEFAULT_REVALIDATE }, ...init });
  if (!res.ok) throw new ApiError(res.status, `${context}: ${res.status}`);
  return res.text();
}
